"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.preview.errors.noId': 'No se proporcionó ID de pago',
    'payment.preview.errors.loadFailed': 'Error al cargar detalles del pago',
    'payment.preview.refreshed': 'Detalles del pago actualizados',
};
